export default ".list_groupe {\n  width: 100%;\n}"